import React, { ReactElement } from 'react';

import { Link } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
  PriceCell,
  UserInfoCell,
} from '../../../../../shared/components/table-components';
import { PaymentIssueInfo } from '../../../../interfaces/PaymentIssueRowInfo';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import {
  localDataFormat,
  localDateTimeFormat,
} from '../../../../../shared/constants/apiDateFormat';
import { getCustomerProfileUrl } from '../../../../utils/getCustomerProfileUrl/getCustomerProfileUrl';
import { getHumanizeSolutionType } from '../../../../../shared/utils/userInfoUtils/getHumanizeSolutionType/getHumanizeSolutionType';
import { PAYMENT_ISSUE_COLUMN, PaymentIssueColumn } from '../PaymentIssueTable.settings';

type PaymentIssueRowProps = {
  paymentIssue: PaymentIssueInfo;
  visibleColumns: PaymentIssueColumn[];
};

const PaymentIssueRow = ({ paymentIssue, visibleColumns }: PaymentIssueRowProps) => {
  const {
    id,
    entityId,
    firstName,
    lastName,
    email,
    subscriptionName,
    price,
    activeSince,
    dateOfUpdate,
    solutionType,
    coach,
  } = paymentIssue;

  const renderColumnsInfo: Record<PaymentIssueColumn, ReactElement> = {
    [PAYMENT_ISSUE_COLUMN.NAME]: (
      <UserInfoCell
        firstName={firstName}
        lastName={lastName}
        email={email}
        href={getCustomerProfileUrl({ solutionType, entityId, customerId: id })}
      />
    ),
    [PAYMENT_ISSUE_COLUMN.SOLUTION]: (
      <GridTableCell>{getHumanizeSolutionType(solutionType)}</GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.COACH]: (
      <GridTableCell>
        {coach ? (
          <Link href={`#!/nutrition/coach-edit/${coach.id}`}>
            {coach.firstName} {coach.lastName}
          </Link>
        ) : (
          '-'
        )}
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.SUBSCRIPTION]: (
      <GridTableCell>{subscriptionName}</GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.PRICE]: <PriceCell price={price} />,
    [PAYMENT_ISSUE_COLUMN.ACTIVE_SINCE]: (
      <GridTableCell>
        {activeSince ? getFormattedDate(activeSince, localDataFormat) : '-'}
      </GridTableCell>
    ),
    [PAYMENT_ISSUE_COLUMN.DATE_OF_UPDATE]: (
      <GridTableCell justify="end">
        {getFormattedDate(dateOfUpdate, localDateTimeFormat)}
      </GridTableCell>
    ),
  };

  return (
    <GridTableRow variant="subRow">
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
};

export { PaymentIssueRow };
